import { Table, TableBody, TableContainer, TableHead, TableRow } from "@mui/material";
import TableCellComponent from "components/table/TableCellComponent";
import TableRowComponent from "components/table/TableRowComponent";
import { formatCurrency } from "utils";
import { useCallback } from "react";
import { QuoteDetail } from "features/quotation/types";

type QuotationDiscountTableProps = {
  quotation: QuoteDetail;
};
/**
 * QuotationDiscountTable component renders a table with a label and optional sx prop for styling.
 * @param {object} root0 - The props object.
 * @param {Quotation} root0.quotation - The quotation data to display in the table.
 */
export default function QuotationDiscountTable({ quotation }: QuotationDiscountTableProps) {
  const quotationDiscountHeader = [
    {
      label: "交換工賃",
      sx: {
        width: "142px",
        backgroundColor: "var(--green-600)",
      },
    },
    {
      label: "処分",
      sx: {
        width: "142px",
        backgroundColor: !quotation.waste_tire_cost_flag ? "var(--offwhite-500)" : "var(--green-600)",
      },
    },
    {
      label: "エアバルブ",
      sx: {
        width: "142px",
        backgroundColor: !quotation.rubber_stem_valve_flag
          ? "var(--offwhite-500)"
          : "var(--green-600)",
      },
    },
    {
      label: "窒素",
      sx: {
        width: "142px",
        backgroundColor: !quotation.nitrogen_inflation_flag
          ? "var(--offwhite-500)"
          : "var(--green-600)",
      },
    },
    {
      label: "ハブ防錆",
      sx: {
        width: "142px",
        backgroundColor: !quotation.hub_rust_prevention_flag
          ? "var(--offwhite-500)"
          : "var(--green-600)",
      },
    },
    {
      label: "パンク補償",
      sx: {
        width: "142px",
        backgroundColor: "var(--offwhite-500)",
      },
    },
    {
      label: "キャッシュバック",
      sx: {
        width: "220px",
        backgroundColor: "var(--offwhite-500)",
      },
    },
    {
      label: "丸め",
      sx: {
        width: "142px",
        backgroundColor: "var(--offwhite-500)",
      },
    },
  ];
  const renderPunctureFlag = useCallback(() => {
    switch (quotation.tire_puncture_flag) {
      case 0:
        return "補償なし";
        break;
      case 2:
        return "2本補償";
        break;
      case 4:
        return "4本補償";
        break;
      default:
        return "補償なし";
    }
  }, [quotation.tire_puncture_flag]);

  const renderCostValue = useCallback(
    (cost: number | null, flag: number | null) => {
      if (flag === null || flag === 0) return "-";
      if (flag && (cost === 0 || cost === null)) return "無料";
      return formatCurrency(cost as number);
    },
    [quotation],
  );

  return (
    <TableContainer component={Table} sx={{ boxShadow: "none", minWidth: "1136px" }}>
      <TableHead>
        <TableRowComponent data={quotationDiscountHeader} type="header" />
      </TableHead>
      <TableBody>
        <TableRow>
          <TableCellComponent sx={{ textAlign: "center", fontWeight: "normal" }}>
            {formatCurrency(quotation.replac_labor_cost)}
          </TableCellComponent>
          <TableCellComponent sx={{ textAlign: "center" }}>
            {renderCostValue(quotation.waste_tire_cost, quotation.waste_tire_cost_flag)}
          </TableCellComponent>
          <TableCellComponent sx={{ textAlign: "center" }}>
            {renderCostValue(quotation.rubber_stem_valve_cost, quotation.rubber_stem_valve_flag)}
          </TableCellComponent>
          <TableCellComponent sx={{ textAlign: "center" }}>
            {renderCostValue(quotation.nitrogen_inflation_cost, quotation.nitrogen_inflation_flag)}
          </TableCellComponent>
          <TableCellComponent sx={{ textAlign: "center" }}>
            {renderCostValue(quotation.hub_rust_prevention_cost, quotation.hub_rust_prevention_flag)}
          </TableCellComponent>
          <TableCellComponent sx={{ textAlign: "center" }}>
            {renderPunctureFlag()}
          </TableCellComponent>
          <TableCellComponent sx={{ textAlign: "center" }}>
            {!quotation.tbl_quote_detail_tire?.[0]?.cb_tire_price && !quotation.tbl_quote_detail_tire?.[0]?.cb_wheel_price ? "期間外" : "期間中"}
          </TableCellComponent>
          <TableCellComponent sx={{ textAlign: "center" }}>{quotation.round_type}</TableCellComponent>
        </TableRow>
      </TableBody>
    </TableContainer>
  )
}
